export default {
  day: 'hari',
  freeTimesLimitTitle: 'Uji coba gratis telah habis hari ini.',
  fileSizeLimitTitle:
    'Ukuran file tidak boleh melebihi 20MB dalam versi gratis.',
  total: 'Total',
  enterCode: 'Memasukkan kode',
  signUpToPurchaseBtn: 'Daftar untuk Membeli',
  goPurchseBtn: 'Pergi ke Pembelian',
  saveTips: 'Hemat Hingga {{num}}%',
  discount: 'Diskon',
  montly: 'Bulanan',
  yearly: 'Tahunan',
  weekly: 'Mingguan',
  week: 'Minggu',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYearly: '$3,75',
  billMonth: '$29,99 Ditagih Bulanan',
  billYear: '$179,99 Ditagih Setiap Tahun',
  AlreadySubscribe: 'Sudah berlangganan?',
  vipTips1: 'Tidak ada batasan ukuran file',
  vipTips2: 'Tidak ada batasan jumlah file yang diproses',
  vipTips3: 'Ubah latar belakang gambar tanpa batas',
  vipTips4: 'Akses ke semua alat gratis & fitur premium',
  purchaseTips: 'Perbarui secara otomatis dan batalkan kapan saja.',
  tips: 'Kiat:',
  promoCodeInvalidTips: 'Kode promo Anda tidak valid',
};
